/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CallControlsType } from './CallControlsType.js';
import {
    CallControlsTypeFromJSON,
    CallControlsTypeFromJSONTyped,
    CallControlsTypeToJSON,
} from './CallControlsType.js';

/**
 * 
 * @export
 * @interface CallControlsConfig
 */
export interface CallControlsConfig {
    /**
     * 
     * @type {CallControlsType}
     * @memberof CallControlsConfig
     */
    type?: CallControlsType;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof CallControlsConfig
     */
    options?: { [key: string]: string; };
}

/**
 * Check if a given object implements the CallControlsConfig interface.
 */
export function instanceOfCallControlsConfig(value: object): boolean {
    return true;
}

export function CallControlsConfigFromJSON(json: any): CallControlsConfig {
    return CallControlsConfigFromJSONTyped(json, false);
}

export function CallControlsConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): CallControlsConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : CallControlsTypeFromJSON(json['type']),
        'options': json['options'] == null ? undefined : json['options'],
    };
}

export function CallControlsConfigToJSON(value?: CallControlsConfig | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': CallControlsTypeToJSON(value['type']),
        'options': value['options'],
    };
}

